export default {
    entityKey: 'phases',
    titles: {
        singular: 'Phase',
        plural: 'Phases'
    }
}
